import type {CancelSubscriptionPanelStep, CancelSurveyReasonIDs, PauseIntervals} from '@Libraries/cancel-subscription-library';

export interface CancelSubscriptionPanelProps {
  showPauseOnly?: boolean;
  hidePause?: boolean;
}

export interface CancelSubscriptionPanelState {
  isReady: boolean;
  isWaitingForAJAXResponse: boolean;
  currentStep: CancelSubscriptionPanelStep;
  cancelReason: CancelSurveyReasonIDs;
  cancelReasonComments: string;
  featureUsages: PremiumFeatureUsages | null;
  pauseInterval: PauseIntervals;
  subscriptionExpiresOnTimestamp: number | null;
  pauseEndTimestamp: number | null;
  transitionDirection: TransitionDirection;
  isRenewalInvoicePending: boolean;
}

export interface PremiumFeatureUsages {
  designFeatures: DesignFeatureUsages;
  publishingActions: PublishingActions;
  publishingAssets: PublishingAssets;
  numBrandKitsCreated: number;
}

export interface DesignFeatureUsages {
  numBackgroundsRemoved: number;
  numAICaptionsCreated: number;
  numAIImagesGenerated: number;
}

export interface PublishingActions {
  numSocialMediaPosts: number;
  numSocialMediaPostsLikes: number;
  numEmailsSent: number;
  numEmailRecipients: number;
}

export interface PublishingAssets {
  numSocialMediaAccountsLinked: number;
  numMailingListsAdded: number;
}

export interface InitCancelSubscriptionPanelResponse {
  featureUsages: PremiumFeatureUsages | null;
  subscriptionExpiresOnTimestamp: number | null;
  isRenewalInvoicePending: boolean;
}

export interface TitleProps {
  text: string;
  showBackButton?: boolean;
}

export const CANCEL_SUBSCRIPTION_PANEL_ID = 'CancelSubscriptionPanel';

export enum TransitionDirection {
  FORWARD = 'forward',
  BACKWARD = 'backward',
}
